import {useCallback, useEffect, useState} from 'react'
import {Playlist} from '../common/types'
import {Spotify} from '../lib/spotify'

export type RenderPlaylist = Playlist

export const useMyPlaylists = (
  userId?: string
): [Playlist[], {loading: boolean; query: () => void}] => {
  const [playlists, setPlaylists] = useState<Playlist[]>([])
  const [loading, setLoading] = useState(true)

  const query = useCallback(async () => {
    if (!userId) return
    setLoading(true)
    const data = await Spotify.getUsersPlaylists(userId)
    setPlaylists(data.items)
    setLoading(false)
  }, [userId])

  useEffect(() => {
    query()
  }, [query])

  return [playlists, {loading, query}]
}
